import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableCell } from '@nagel-types';

@Component({
    selector: 'app-date-cell',
    imports: [DatePipe],
    templateUrl: './date-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateCellComponent {
    cell = input.required<TableCell>();

    readonly date = computed(() => new Date(this.cell().value as string));
}
